import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#1F222E] bg-[#0B0C10] relative z-10" data-testid="footer">
      <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src="https://customer-assets.emergentagent.com/job_strategy-hub-236/artifacts/m6vj62st_12908.jpg" alt="Martin Ramnarine LLC" className="h-11 w-11 object-contain rounded-sm" />
            <span className="font-display text-lg tracking-[0.15em] text-white uppercase">Martin Ramnarine LLC</span>
          </div>
          <p className="mt-6 text-[#9CA3AF] max-w-md leading-relaxed text-sm">
            A full-service consulting firm empowering entrepreneurs, creators, and business owners to turn vision into reality — 100% online, no borders, no limits.
          </p>
          <a href="https://instagram.com/martinramnarinellc" target="_blank" rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2.5 text-sm text-[#9CA3AF] hover:text-[#D4AF37] transition-colors group" data-testid="footer-instagram">
            <span className="h-9 w-9 grid place-items-center border border-[#1F222E] group-hover:border-[#D4AF37] rounded-sm transition-colors">
              <Instagram size={18} />
            </span>
            @martinramnarinellc
          </a>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Explore</p>
          <ul className="mt-5 space-y-3 text-sm text-[#9CA3AF]">
            <li><a href="/#services" className="hover:text-white transition-colors">Services</a></li>
            <li><a href="/#different" className="hover:text-white transition-colors">What's Different</a></li>
            <li><Link to="/dashboard" className="hover:text-white transition-colors">Member Courses</Link></li>
            <li><a href="/#inquiry" className="hover:text-white transition-colors">Book Consultation</a></li>
            <li><Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer & Terms</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Contact</p>
          <ul className="mt-5 space-y-3 text-sm text-[#9CA3AF]">
            <li><a href="mailto:mdr@martinramnarinellc.com" className="hover:text-white transition-colors break-all">mdr@martinramnarinellc.com</a></li>
            <li>Online · Worldwide</li>
          </ul>
        </div>
      </div>
      <div className="px-6 md:px-12 lg:px-24 py-6 border-t border-[#1F222E] flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#6B7280]">
        <span>© {new Date().getFullYear()} Martin Ramnarine LLC. All rights reserved.</span>
        <span className="font-mono tracking-wider">Consulting • Branding • Entertainment & Media</span>
      </div>
    </footer>
  );
}
